import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import './App.css';

import { ConfirmProvider } from "material-ui-confirm";

import AddCorreo from "./components/addcorreo.component";
import AddUsuario from "./components/addusuario.component";
import Admin from "./components/admin.component";
import Causal from "./components/causal.component";
import CausalGerencia from "./components/causalgg.component";
import CausalJefeRRHH from "./components/causaljrrhh.component";
import Finiquito from "./components/finiquito.component";
import FinquitoFin2 from "./components/finiquitofin2.component";
import FiniquitoFinalizar from "./components/finiquitofinalizar.component";
import FiniquitoGer from "./components/finiquitoger.component";
import FiniquitoGerGen from "./components/finiquitogergen.component";
import FiniquitoJefeRRHH from "./components/finiquitojeferrhh.component";
import Finiquito2 from "./components/finiquitopt2.component";
import Finiquito3 from "./components/finiquitopt3.component";
import FiniquitoRRLL from "./components/finiquitorrll.component";
import Inicio from "./components/inicio.component";
import Login from "./components/login.componentj";
import MutuoADC from "./components/mutuoadc.component";
import MutuoADCFinal from "./components/mutuoadcfinal.component";
import MutuoFinanzas from "./components/mutuofinanzas.component";
import MutuoGerGen from "./components/mutuogergen.component";
import Panel from "./components/panel.component";
import PanelCompleto from "./components/panelcompleto.component";
import PanelRRHH from "./components/panelrrhh.component";
import Persona from "./components/persona.component";
import PersonasDev from "./components/personasdesv.component";
import Salida from "./components/salida.component";
import Salidarrhh from "./components/salidarrhh.component";

function App() {
  let navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('user');
    navigate("/login");
  }

  return (
    <ConfirmProvider>
    <div>
      <nav className="navbar navbar-expand navbar-dark bg-dark">
        <div className="container-fluid">
          <a href="#" className="navbar Brand"><img src="/img/logo_ecora_blanco.png" alt="Ecora S.A." width="200" height="60" /></a>
          <form className="d-flex">
            {localStorage.getItem('user') ? (<button className="btn btn-primary" onClick={logout}>Salir</button>) : ""}
          </form>
        </div>
      </nav>
      <div className="container mt-3">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/finiquito/:code" element={<Finiquito />} />
          <Route path="/finiquito/:code/:id_causal" element={<Finiquito />} />
          <Route path="/persona" element={<Persona />} />
          <Route path="/inicio/:code" element={<Inicio />} />
          <Route path="/finiquitopt2/:id_causal" element={<Finiquito2 />} />
          <Route path="/finiquito3/:id_causal" element={<Finiquito3 />} />
          <Route path="/desvincular" element={<PersonasDev />} />
          <Route path="/salida" element={<Salida />} />
          <Route path="/salidar" element={<Salidarrhh />} />
          <Route path="/agregarusuario" element={<AddUsuario />} />
          <Route path="/login" element={<Login />} />
          <Route path="/agregarcorreo" element={<AddCorreo />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/causal" element={<Causal />} />
          <Route path="/finiquitoger/:id_causal" element={<FiniquitoGer />} />
          <Route path="/finiquitogergen/:id_causal" element={<FiniquitoGerGen />} />
          <Route path="/panel" element={<Panel />} />
          <Route path="/causalgerencia" element={<CausalGerencia />} />
          <Route path="/causaljeferrhh" element={<CausalJefeRRHH />} />
          <Route path="/mutuoacuerdo/:rut" element={<MutuoADC />} />
          <Route path="/mutuofinanzas/:id_mutuo" element={<MutuoFinanzas />} />
          <Route path="/mutuoadcfinal/:id_mutuo" element={<MutuoADCFinal />} />
          <Route path="/mutuogerencia/:id_mutuo" element={<MutuoGerGen />} />
          <Route path="/panelrrhh" element={<PanelRRHH />} />
          <Route path="/finiquitojrrhh/:id_causal" element={<FiniquitoJefeRRHH />} />
          <Route path="/finiquitorrll/:id_causal" element={<FiniquitoRRLL />} />
          <Route path="/finiquitofin2/:id_causal" element={<FinquitoFin2 />} />
          <Route path="/finiquitofinalizar/:id_causal" element={<FiniquitoFinalizar />} />
          <Route path="/panelecora" element={<PanelCompleto />} />
        </Routes>
      </div>
    </div>
    </ConfirmProvider>
  );
}

export default App;
